<!-- only start loading the dep when we want to show the dialog -->

<svelte:head>
    {#if opened && !filePicker}
        <script src="https://widget.cloudinary.com/v2.0/global/all.js" type="text/javascript" on:load={() => depLoaded = true}></script>
    {/if}
</svelte:head>

<script>
    import LoadingSpinner from "../LoadingSpinner.svelte";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    // where the widget will be initialized into
    let filePicker;

    // state flags (TODO: read only)
    export let depLoaded = false;
    export let opened = false;

    // values to export (TODO: readonly)
    export let url;
    export let urlThumb;

    // If specified, enforce the given aspect ratio on the selected region when performing interactive cropping. The aspect ratio is defined as width/height. For example, 0.5 for a portrait oriented rectangle or 1 for square.
    // Relevant only if the cropping feature is enabled.
    // Note: If the user tries to upload an asset with the exact same aspect ratio, the 'crop' button will start off disabled. The user will either have to click the 'skip' button, or slightly modify the cropping region to enable the 'crop' button.
    // Example: 0.5
    export let cropRatio = null;
    export let showResultImg = false;

    // api keys
    const bucket = "evalueaid";
    //const id = "976128181917152";
    //const key = "R8v-Kew-Sg6oEbliVFyclvkMxEI";

    let widgetOptions = {
        cloudName: 'evalueaid',
        uploadPreset: 'evalueaid_unsigned',
        multiple: false,
        minImageWidth: 300,
        croppingAspectRatio: cropRatio,
        sources: ["local", "url", "camera"]
    };

    const onUpload = (error, result) => {
        if (!error && result && result.event === "success") {
            console.log('Done! Here is the image info: ', result.info);
            url = result.info.url;
        }
        opened = false;
        dispatch("upload", url);
    };

    // disable the button when we have clicked it
    // (we want to show the dialog) but the dialog hasnt loaded yet
    $: disabled = opened && !depLoaded;

    // track the state of the opened and deploaded flags
    // and display the file uploader when it should be open
    // on the premise that it is loaded
    $: {
        if (!opened) {
            // no need to show
        } else if (depLoaded) {
            filePicker.open();
        } else {
            // still loading
        }
    }

    // as soon as the dependency is loaded, initialize the widget
    $: if (depLoaded && !filePicker) {
        filePicker = cloudinary.createUploadWidget(widgetOptions, onUpload);
    }
</script>

<button {disabled} on:click|preventDefault={() => opened = true}>
    {#if !opened}
        {#if !url}
            set image...
        {:else}
            replace image...
        {/if}
    {:else if !depLoaded}
        <LoadingSpinner />
    {:else}
        <LoadingSpinner />
    {/if}
</button>

{#if url && showResultImg}
    <img src={url} />
{/if}

<style>
    button {
        width: 200px;
        padding: 10px;
        margin-bottom: 10px;
    }
</style>